// Performance Monitoring Script - Deferred for mobile
(function() {
  'use strict';
  
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || 
                   window.innerWidth <= 768;
  
  // Performance metrics storage
  const performanceData = {
    fcp: null,
    lcp: null,
    fid: null,
    cls: null,
    ttfb: null,
    fmp: null,
    si: null,
    tti: null,
    tbt: null
  };

  // Core Web Vitals thresholds
  const thresholds = {
    fcp: { good: 1800, poor: 3000 },
    lcp: { good: 2500, poor: 4000 },
    fid: { good: 100, poor: 300 },
    cls: { good: 0.1, poor: 0.25 }
  };

  // Enhanced performance monitoring with mobile scroll optimization awareness
  const initMonitoring = () => {
    // Skip if mobile scroll optimizer is handling performance monitoring
    if (window.mobileScrollOptimizer && isMobile) {
      // Mobile scroll performance monitoring handled by Mobile Scroll Optimizer
      return;
    }
    // First Contentful Paint
    if ('PerformanceObserver' in window) {
      const fcpObserver = new PerformanceObserver((list) => {
        const entries = list.getEntries();
        const fcp = entries[entries.length - 1];
        performanceData.fcp = fcp.startTime;
        logMetric('FCP', fcp.startTime, 'ms');
      });
      fcpObserver.observe({ entryTypes: ['paint'] });

      // Largest Contentful Paint
      const lcpObserver = new PerformanceObserver((list) => {
        const entries = list.getEntries();
        const lcp = entries[entries.length - 1];
        performanceData.lcp = lcp.startTime;
        logMetric('LCP', lcp.startTime, 'ms');
      });
      lcpObserver.observe({ entryTypes: ['largest-contentful-paint'] });

      // First Input Delay
      const fidObserver = new PerformanceObserver((list) => {
        const entries = list.getEntries();
        entries.forEach(entry => {
          performanceData.fid = entry.processingStart - entry.startTime;
          logMetric('FID', performanceData.fid, 'ms');
        });
      });
      fidObserver.observe({ entryTypes: ['first-input'] });

      // Cumulative Layout Shift
      const clsObserver = new PerformanceObserver((list) => {
        let clsValue = 0;
        const entries = list.getEntries();
        entries.forEach(entry => {
          if (!entry.hadRecentInput) {
            clsValue += entry.value;
          }
        });
        performanceData.cls = clsValue;
        logMetric('CLS', clsValue, '');
      });
      clsObserver.observe({ entryTypes: ['layout-shift'] });
    }

    // Time to First Byte
    if (performance.timing) {
      performanceData.ttfb = performance.timing.responseStart - performance.timing.requestStart;
      logMetric('TTFB', performanceData.ttfb, 'ms');
    }

    // Speed Index (estimated)
    setTimeout(() => {
      if (performanceData.fcp && performanceData.lcp) {
        performanceData.si = (performanceData.fcp + performanceData.lcp) / 2;
        logMetric('SI', performanceData.si, 'ms');
      }
    }, 1000);

    // Time to Interactive (estimated)
    setTimeout(() => {
      if (performanceData.fcp && performanceData.lcp) {
        performanceData.tti = performanceData.lcp + 2000; // Rough estimate
        logMetric('TTI', performanceData.tti, 'ms');
      }
    }, 2000);
  };

  // Log performance metrics
  function logMetric(name, value, unit) {
    const score = getScore(name, value);
    const emoji = score === 'good' ? '🟢' : score === 'needs-improvement' ? '🟡' : '🔴';
    
    // Performance metric logged: ${name}: ${value}${unit} (${score})
    
    // Send to analytics if available
    if (window.gtag) {
      gtag('event', 'custom_performance_metric', {
        metric_name: name,
        metric_value: value,
        metric_score: score
      });
    }
  }

  // Get performance score
  function getScore(metric, value) {
    if (!thresholds[metric.toLowerCase()]) return 'unknown';
    
    const { good, poor } = thresholds[metric.toLowerCase()];
    
    if (value <= good) return 'good';
    if (value <= poor) return 'needs-improvement';
    return 'poor';
  }

  // Calculate overall performance score
  function calculateOverallScore() {
    const metrics = ['fcp', 'lcp', 'fid', 'cls'];
    let goodCount = 0;
    let totalCount = 0;
    
    metrics.forEach(metric => {
      if (performanceData[metric] !== null) {
        totalCount++;
        if (getScore(metric, performanceData[metric]) === 'good') {
          goodCount++;
        }
      }
    });
    
    if (totalCount === 0) return 0;
    return (goodCount / totalCount) * 100;
  }

  // Report final performance data
  function reportPerformance() {
    setTimeout(() => {
      const overallScore = calculateOverallScore();
      // Overall Performance Score: ${overallScore.toFixed(1)}%
      
      // Log all collected metrics
      Object.keys(performanceData).forEach(metric => {
        if (performanceData[metric] !== null) {
          const unit = metric === 'cls' ? '' : 'ms';
          // Performance metric: ${metric.toUpperCase()}: ${performanceData[metric]}${unit}
        }
      });
      
      // Send final report to analytics
      if (window.gtag) {
        gtag('event', 'custom_performance_report', {
          overall_score: overallScore,
          metrics: performanceData
        });
      }
    }, 5000);
  }
  
  if (isMobile) {
    // Defer monitoring on mobile to prevent scroll blocking
    window.addEventListener('load', () => {
      setTimeout(initMonitoring, 1000);
    });
  } else {
    // Initialize immediately on desktop
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMonitoring);
    } else {
      initMonitoring();
    }
  }

  // Report final performance after page load
  window.addEventListener('load', reportPerformance);

  // Expose performance data globally for debugging
  window.performanceData = performanceData;
})();
